var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1604 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb651e;fill-rule:evenodd}"))), /*#__PURE__*/React.createElement("g", {
    id: "logo-y-combinator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M0 320h320V0H0v320z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M173 175.87V247h-27v-71.13L77.09 73H110l49.63 76L209 73h32.91L173 175.87z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M507.61 107.34c-29.54 0-51.76 22.9-51.76 52.44s22.22 52.67 51.76 52.67A49.64 49.64 0 0 0 552 186.11l25.42 15.12a81.53 81.53 0 1 1 0-82.9L552 133.44c-8.93-16.48-25.42-26.1-44.42-26.1",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M675 180.39c0-18.55-13.52-32.52-30.92-32.52-17.86 0-31.37 14-31.37 32.52s13.51 32.52 31.37 32.52c17.18 0 30.92-14 30.92-32.52m-91.38 0a60.23 60.23 0 1 1 60.46 60.23 60.07 60.07 0 0 1-60.46-60.23",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M893 170.84V238h-29v-62.06c0-17.4-8.48-28.4-21.31-28.4-13.07 0-22.69 11-22.69 28.4V238h-28v-62.06c0-17.4-8.75-28.4-21.65-28.4s-22.35 11-22.35 28.4V238h-29V123h29v14.72c7.1-11 18.1-17.94 31.61-17.94 14.66 0 26.34 8.28 33.45 21.16 7.33-11.5 20.84-21.16 37.79-21.16 25.43 0 42.15 22.54 42.15 51.06",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M996.06 181.62c0-19.24-11.91-33-28.62-33-16.26 0-28.63 13.06-28.63 32.75 0 19.47 12.59 32.75 29.08 32.75 16.26-.23 28.17-13.74 28.17-32.52M973.57 241c-16 0-27.84-7.31-34.57-17.37V238h-29V78h29v59c7-9.37 18.79-16.23 34.1-16.23 29.7 0 52.44 25.6 52.9 60.12.46 35-22.74 60.11-52.43 60.11",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M1038 238h29V123h-29Zm-3.7-147.61c0-9.84 8.24-17.17 18.09-17.17 9.62 0 17.63 7.33 17.63 17.17s-8 17.18-17.63 17.18c-9.85 0-18.09-7.33-18.09-17.18Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M1192 171.3V238h-28v-60.46c0-18.55-9.68-30-23.73-30-15.44 0-26.27 14-26.27 30.46v60h-28V123h28v14.49a42.44 42.44 0 0 1 34.89-17.71c25.78 0 43.11 22.08 43.11 51.52",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M1280 187v-2.48l-29.31 5.73c-9.85 2.29-15.8 7.33-15.8 14 0 7.07 6.55 12.44 17.15 12.12 15.39-.46 28-13.94 28-29.34m28-18.38V238h-28v-13.28a51.74 51.74 0 0 1-36.53 16.28c-19.51 0-36.72-12.83-36.72-34.81 0-20.84 15.6-32.75 38.78-37.33l33.74-6.41c-2.29-9.62-9.64-17-20.65-17s-21.35 6.87-27.54 15.57L1210 145.71c10.79-15.11 29.84-25.19 48.66-25.19 28.23 0 49.34 19.47 49.34 48.09",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M1367 149v48.26c0 9.39 4.12 13.74 12.6 13.74h14.4v27h-18.41c-24.54 0-36.59-12-36.59-37.15V149h-21v-26h20V94.6l29-8.93V123h27v26Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M1494.81 180.39c0-18.55-13.51-32.52-30.91-32.52-17.86 0-31.38 14-31.38 32.52s13.52 32.52 31.38 32.52c17.17 0 30.91-14 30.91-32.52m-91.37 0a60.23 60.23 0 1 1 60.46 60.23 60.07 60.07 0 0 1-60.46-60.23",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M1604 120.48v27.94c-25.9 0-37 12.59-37 29.08V238h-28V123h28v14.43c7.86-10.31 20.58-17 37-17",
    className: "cls-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYc);
export default __webpack_public_path__ + "static/media/YC.dc8128502ba2534708c7b4a5a14b14cd.svg";
export { ForwardRef as ReactComponent };